<template>
  <b-modal
    id="document-preview-modal"
    :title="previewFile.name"
    size="xl"
    hide-footer
    @hidden="$emit('close')"
  >
    <div v-if="isLoading" class="preview-iframe">
      <LmComponentLoading />
    </div>
    <div v-else>
      <div class="text-center">
        <b-row>
          <b-col class="col-12 col-md-11">
            <blockquote slot="content" v-if="allowSeal && !sealFixedLocation" class="blockquote text-center">
              <p class="mb-0 text-danger">{{$t('important')}}</p>
              <footer class="blockquote-footer">
              {{$t('seal_important_message')}}
              </footer>
            </blockquote>
          </b-col>

          <b-col class="col-12 col-md-1">
            <a-badge
            id="popover-target-1"
              v-if="showBadge"
              :count="badgeCount"
              :showZero="badgeShowZero"
              :title="badgeShowTitle"
              :number-style="{ backgroundColor: badgeColor || 'red' }"
            >
              <a-tooltip :title="$t('seals_remove')" placement="left">
                <a-button @click="onRemoveSealPreviewContainers" icon="delete"> </a-button>
              </a-tooltip>
            </a-badge>
          </b-col>
        </b-row>
      </div>
      <LmFileViewer
        ref="lmFileViewer"
        :files="files"
        :showNavigator="false"
        :dynamicSealEnabled="allowSeal && !sealFixedLocation"
        @onSealDynamicCoordinates="onSealDynamicCoordinates"
        @onReloadPreview="onPreview"
      />
    </div>
  </b-modal>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import LmFileViewer from '@/components/LmFileViewer'

export default {
  components: {
    LmFileViewer
  },
  props: {
    dataToRender: {
      type: Object,
      required: true
    },
    documentTypeId: {
      type: String,
      required: true
    },
    allowSeal: {
      type: Boolean,
      default: false
    },
    sealFixedLocation: {
      type: Boolean,
      default: true
    },
    savedSealDynamicCoordinates: {
      type: Array
    },
    badgeCount: {
      type: Number
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    badgeShowZero: {
      type: Boolean,
      default: false
    },
    badgeShowTitle: {
      type: String,
      default: ''
    },
    badgeColor: {
      type: String
    }
  },
  data () {
    return {
      files: [],
      isLoading: false,
      previewFile: {
        name: '',
        src: ''
      },
      sealDynamicCoordinates: []
    }
  },
  computed: {
    sealsCounter () {
      return this.sealDynamicCoordinates?.length
    }
  },
  methods: {
    async onPreview () {
      try {
        this.isLoading = true
        await this.$bvModal.show('document-preview-modal')
        const pdfLocation = await commonsApi.axiosPostWrapper('/documents/preview', {
          id: this.$route.params.id,
          documentTypeId: this.documentTypeId,
          ...this.dataToRender
        })

        this.previewFile = pdfLocation.data
        this.files = [
          {
            name: this.dataToRender?.documentName,
            path: this.previewFile.src,
            src: this.previewFile.src
          }
        ]
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    onSealDynamicCoordinates (sealDynamicCoordinates) {
      this.sealDynamicCoordinates = sealDynamicCoordinates
      this.$emit('onSealDynamicCoordinates', this.sealDynamicCoordinates)
    },

    onRemoveSealPreviewContainers () {
      this.$refs.lmFileViewer.removeSealPreviewContainers()
    }
  },
  created () {
    this.sealDynamicCoordinates = { ...this.savedSealDynamicCoordinates }
  }
}
</script>

<style lang="sass" scoped>
.preview-iframe
  min-height: 80vh
</style>
